import styled from 'styled-components';
import Colors from 'library/constants/colors';
import { IconPencil } from 'library/styles/icon';
import { Container as Filters, Wrapper } from 'library/components/filters/styles';
import { Container as Search, SearchInput } from 'library/components/search/styles';
import { Container as SearchQueryContainer } from 'library/components/search-query/styles';
import { Options as RadioGroup } from 'library/components/radio-group/styled';
import { StyledDescription, StyledTitle } from 'library/components/no-content/styles';
import { Container } from '../../no-content/styles';

export const CatalogueContainer = styled.div`
  ${Search} {
    padding: 18px 30px;
    width: 100%;
    height: auto;
    max-width: 100%;
    background-color: ${Colors.shade07};
    // background: ${Colors.shade07};

    i.icon-colors {
      display: none;
    }
    
    input {
      // background: ${Colors.shade08};
    }
  }

  ${StyledTitle} {
    font-size: 18px;
  }

  ${StyledDescription} {
    font-size: 14px;
  }
  
  ${Wrapper} {
    display: flex;
    flex-direction: row;
    //justify-content: center;
    width: 100%;
    background: ${Colors.shade07};
  }


  ${SearchInput} {
    background-color: #fff;
    border-radius: 48px;
  }


  ${SearchQueryContainer} {
    //width: 100%;
    //display: flex;
    //flex-direction: row;
    //justify-content: space-between;
    //flex-basis: max-content;
    box-shadow: none;
    background-color: ${Colors.shade07};
    padding-bottom: 30px;
    
    > div {
      box-shadow: none !important;
    }
  }
  
  ${Filters} {
    display: flex;
    flex-direction: column;
    justify-content: start;
    align-items: flex-start;
    width: 250px;
    padding: 32px 40px;
    background: ${Colors.shade07};
    box-shadow: none !important;

    ${RadioGroup} {
      margin-top: 10px;
      margin-bottom: 30px;
    }
  }

`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 32px 40px;
  width: ${({ isLongerModal }) => (isLongerModal ? '938px' : '638px')};
  position: relative;
  background: ${({ isLongerModal }) => (isLongerModal ? `${Colors.shade07}` : `${Colors.shade08}`)};
`;

export const Info = styled.div`
  margin-top: 20px;
  width: 100%;
  font-size: 16px;
  color: ${Colors.shade09};
`;

export const ExitingItemsContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 32px 40px;
  width: 100%;
  position: relative;
  background: ${Colors.shade08};
  //height: auto;
  //max-height: 100vh;
  //max-height: 780px;
  //overflow-x: hidden;
  box-shadow: none;
  overflow-y: auto;
  height: 600px;

  div {
    box-shadow: none;
  }

  ${Container} {
    justify-content: flex-end;
    transform: none;
  }
  
  &::-webkit-scrollbar {
    width: 8px;
    background: ${Colors.shade08};
  }  
  &::-webkit-scrollbar-track {
    //width: 18px;
  }
  &::-webkit-scrollbar-thumb {
    background: ${Colors.shade400};
    border-radius: 8px;
    height: 615px;
    margin: 5px;
    width: 8px;
  }
`;

export const Text = styled.h4`
  font-size: 18px;
  line-height: 22px;
  color: ${Colors.shade01};
  margin: 0;
`;

export const Input = styled.input`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 584px;
  height: 56px;
  background:  ${Colors.shade08};
  box-shadow: 0 1px 0 ${Colors.shade06};
  border-radius: 8px;
  border: none;
  cursor: pointer;
  padding-left: 52px;
  ::placeholder {color: ${Colors.shade01}};
  &:hover {
    background: ${Colors.shade07};
    box-shadow: 0 2px 0 ${Colors.shade04};
  }
  &:focus {
    background: ${Colors.shade07};
    box-shadow: 0 2px 0 ${Colors.violet};
    outline: none;
  }
`;

export const Icon = styled(IconPencil)``;

export const PickColorText = styled.p`
  font-size: 16px;
  line-height: 24px;
  color: ${Colors.shade01};
  margin: 0;
`;

export const ColorsContainer = styled.div`
  margin-top: 20px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  height: 60px;
  align-items: center;
`;

export const IconU = styled.i`
  font-size: 140px;
`;

export const Item = styled.div`
  margin: 2px 0;
  height: 60px;
  display: flex;
  flex-direction: row;
  background: ${Colors.shade07};
  align-items: center;
  border-radius: 4px;
  padding: 0 10px;
  justify-content: space-between;
  position: relative;
`;

export const ImageContainer = styled.div`
  display: flex;
  justify-content: center;
  width: 40px;
  height: 40px;
  margin-right: 20px;
  border-radius: 4px;
`;

export const Image = styled.img`
  width: 100%;
`;

export const CheckIcon = styled.i`
  font-size: 32px;
  color: ${Colors.violet};
  display: none;
`;

export const ProjectText = styled.p`
  display: flex;
  flex-direction: row;
  align-items: center;
  font-weight: bold;
  font-size: 14px;
  line-height: 17px;
  color: ${(props) => (props.selected ? `${Colors.shade08}` : `${Colors.shade02}`)};

  margin-left: 20px;
`;

export const IconPlus = styled.i`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  font-size: 32px;
  color: ${Colors.violet};
`;

export const BottomContent = styled.div`
  display: flex;
  flex-direction: row;
  background: ${Colors.shade07};
  margin: 2px 0;
  max-height: 780px;
`;

export const SortContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 300px;
  background: ${Colors.shade07};
  padding-top: 16px;
  padding-left: 9px;
`;

export const ExitingItem = styled.div`
  padding: 18px;
  background: ${Colors.shade07};
  width: 604px;
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 4px;
  border-radius: 4px;
  cursor: pointer;
  position: relative;
  
  span {
    word-break: break-word;
    padding-right: 35px;
    padding-top: 5px;

    &:last-of-type {
      color: ${Colors.shade10};
    }
  }

  ${({ isSelected }) => (isSelected ? `
    
    i {
      opacity: 1;
      display: block;
      position: absolute;
      right: 5px;
      font-weight: 900;
    }
  ` : `
      :hover {
        i {
          opacity: 0.5;
          display: block;
          position: absolute;
          right: 5px;
          font-weight: 900;
        }
      }
  `)};
`;

export const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const TopText = styled.p`
  font-weight: bold;
  font-size: 14px;
  line-height: 17px;
  color: ${Colors.shade02};
  margin: 0 0 4px 0;
`;

export const BarcodeContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 24px 40px;
  background: ${Colors.shade07};
  border-radius: 24px;
  width: 558px;
`;

export const BarcodeTitle = styled.h3`
  font-weight: bold;
  font-size: 24px;
  line-height: 29px;
  color: ${Colors.shade02};
  margin-top: 0;
  margin-bottom: 24px;
`;

export const BarcodeList = styled.ol`
  margin: 0;
  padding-left: 20px;
`;

export const InstructionElement = styled.li`
  font-size: 18px;
  line-height: 28px;
`;

export const RadioLabel = styled.label`
  position: absolute;
  top: 25%;
  left: 10px;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: white;
  border: 2px solid ${Colors.violet};
`;

export const CheckboxLabel = styled.label`
  position: absolute;
  top: 25%;
  left: 10px;
  width: 16px;
  height: 16px;
  border-radius: 1px;
  background: white;
  border: 2px solid ${Colors.violet};
`;

export const Line = styled.div`
  width: 100%;
  background: ${Colors.shade06};
  height: 1px;
  margin: 4px 0;
  display: ${({ none }) => (none || 'block')};
`;
